module.exports = __webpack_public_path__ + "img/58cfc99.jpg";